import { makeStyles } from '@material-ui/styles';
import hexToRGBA from '~helpers/hex-to-rgba';

const useStyles = makeStyles(theme => ({
  modal: {
    width: 880,

    '& .ant-legacy-form-item': {
      paddingBottom: 0,

      '& .ant-legacy-form-item-label': {
        paddingBottom: 12,
      },

      '& .tenancy-unit-select > div': {
        marginLeft: -1,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        color: hexToRGBA('#000', 0.85),
        zIndex: 0,

        '&:hover': {
          zIndex: 2,
        },
      },

      '& .tenancy-unit-input': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        zIndex: 1,
      },
    },
  },
  wrapper: {
    position: 'relative',
  },
  header: {
    padding: 32,
  },
  closeButton: {
    position: 'absolute',
    right: 28,
    top: 28,
    color: '#999',
    cursor: 'pointer',
  },
  title: {
    fontFamily: theme.typography.fontFamilySmall,
    fontSize: 18,
    lineHeight: '24px',
    color: '#9E9E9E',
    fontWeight: 400,
    margin: 0,
  },
  body: {
    maxHeight: 'calc(100vh - 184px)',
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingBottom: 104,
  },
  section: {},
  sectionTitle: {
    ...theme.typography.h4,
    position: 'relative',
    marginBottom: 12,
    marginLeft: 32,
    marginRight: 32,
    paddingLeft: 11,

    '&:before': {
      content: '""',
      position: 'absolute',
      top: 4,
      left: 0,
      width: 3,
      height: 16,
      backgroundColor: theme.colors.mainGreen6,
    },
  },
  sectionSummary: {
    ...theme.typography.body4,
    color: theme.colors.captionColor,
    marginLeft: 32,
    marginRight: 32,
    marginBottom: 20,
  },
  tenancyLengthTiers: {
    margin: '0 32px',
  },
  formTierDefine: {
    padding: '20px 24px !important',
    marginBottom: 32,
    borderRadius: 2,
    backgroundColor: theme.colors.gray2,
  },
  rentPaymentOption: {
    '&:not(:last-child)': {
      paddingBottom: 20,
    },

    '& .option--title': {
      width: '100%',
      height: 36,
      ...theme.typography.body4,
      lineHeight: '36px',
      padding: '0 32px',
      marginBottom: 20,
      backgroundColor: theme.colors.gray3,

      '&__index': {
        fontWeight: '600 !important',
        color: `${theme.colors.disableColor} !important`,
      },

      '& span': {
        paddingRight: 4,
        color: theme.colors.titleColor,
      },
    },

    '& .option--extra-form': {
      margin: '0 32px !important',
      padding: '20px 0 0 0',
      border: '1px solid rgba(0, 0, 0, 0.06)',
      borderTop: 'none',
      '& .ant-select-selection:hover': {
        cursor: 'text',
      },
      '&__item': {
        marginBottom: 18,

        '& .ant-checkbox-group span, & .ant-radio-group span': {
          fontSize: 12,
          color: theme.colors.titleColor,
        },
      },

      '& .ant-input-number-handler-wrap': {
        opacity: '1 !important',
      },

      '&-tenancy-week': {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        fontSize: 12,
        marginRight: 32,
        color: theme.colors.disableColor,
      },
    },
    '& .option--guarantorLocation': {
      width: '100%',
      margin: '6px 20px 24px 20px',
      padding: '20px 24px 20px 24px',
      background: '#FAFAFA',
      borderRadius: 2,
      '& .ant-legacy-form-item .ant-legacy-form-item-label': {
        paddingBottom: 8,
      },
      '& .option--extra-form__item': {
        marginBottom: 0,
      },
    },
    '& #RentPaymentSettingModal_guarantorCountry': {
      width: '100%',
    },
    '& .option--extra-form__noPayment': {
      width: 400,
    },
  },
  formRentPayment: {
    margin: '0 32px',
    paddingBottom: '0 !important',

    '& .ant-checkbox-group': {
      width: '100%',
    },

    '& .option--checkbox': {
      width: '100%',
      height: 40,
      lineHeight: '40px',
      paddingLeft: 16,
      borderRadius: 2,
      backgroundColor: theme.colors.gray2,

      '&:first-child': {
        marginBottom: 8,
      },

      '& span': {
        fontSize: 12,
        color: theme.colors.titleColor,
      },

      '& .explain': {
        color: theme.colors.captionColor,
        paddingLeft: 4,
      },
    },
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 72,
    lineHeight: '72px',
    textAlign: 'right',
    paddingRight: 32,
    borderTop: '1px solid #E7E7E7',
    backgroundColor: theme.colors.gray1,
    zIndex: 1000,

    '& .ant-btn': {
      height: 40,
      lineHeight: '40px',
    },
  },
  saveButton: {
    marginLeft: 16,
    fontWeight: 600,
  },

  // tier-define-control
  buttonGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    marginBottom: 16,

    '& .tier--button__set': {
      marginRight: 8,
    },

    '& .tier--button__item': {
      padding: '4px 12px',
      marginRight: 8,
      marginBottom: 8,
      borderRadius: 2,
      color: theme.colors.titleColor,
      border: `1px solid ${theme.colors.gray4}`,
      backgroundColor: theme.colors.gray3,
    },

    '& .tier--button__close': {
      display: 'inline-block',
      width: 10,
      height: 10,
      fontSize: 10,
      color: theme.colors.captionColor,
      marginLeft: 4,
    },
  },
  tierChart: {},
  tierChartHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 10,
    lineHeight: '20px',
    color: theme.colors.disableColor,

    '& .tier--tag': {
      position: 'relative',
      cursor: 'pointer',
    },

    '& .tier--tag__start': {
      paddingLeft: 10,
    },

    '& .tier--tag__end': {
      paddingRight: 10,
    },

    '& .tier--tag__start:before, & .tier--tag__end:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      width: 0,
      height: 0,
      border: `3px solid ${theme.colors.disableColor}`,
      borderTopColor: 'transparent',
      borderBottomColor: 'transparent',
      transform: 'translateY(-3px)',
    },

    '& .tier--tag__start:before': {
      left: 0,
      borderLeftWidth: 5,
      borderRightColor: 'transparent',
    },

    '& .tier--tag__end:after': {
      right: 0,
      borderRightWidth: 5,
      borderLeftColor: 'transparent',
    },
  },
  tierChartMain: {
    position: 'relative',
    paddingTop: 8,
    paddingBottom: 8,
    borderLeft: `1px solid ${theme.colors.gray5}`,
  },
  tierChartLine: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    borderRight: `1px solid ${theme.colors.gray5}`,
  },
  tierChartItemWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 24,
    backgroundColor: theme.colors.gray4,

    '&:not(:last-child)': {
      marginBottom: 8,
    },

    '& .tier--index': {
      fontSize: 12,
      lineHeight: '22px',
      color: theme.colors.disableColor,
      fontWeight: 700,
      paddingLeft: 8,
    },
  },
  tierChartItem: {
    position: 'relative',
    height: '100%',
    lineHeight: '24px',
    paddingLeft: 14,
    paddingRight: 14,
    borderRadius: 4,
    overflow: 'hidden',
    cursor: 'pointer',
    boxSizing: 'border-box',
    backgroundColor: theme.colors.mainGreen2,
    zIndex: 1000,
    boxSizing: 'border-box',

    '& .tier--item__main': {
      flex: 1,
      overflow: 'hidden',
      fontSize: 10,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',

      '& .tier--item__index': {
        color: theme.colors.titleColor,
        fontWeight: 600,
      },

      '& .tier--item__range': {
        color: theme.colors.captionColor,
        paddingLeft: 8,
      },
    },

    '& .tier--item__start, & .tier--item__end': {
      position: 'absolute',
      top: 0,
      bottom: 0,
      display: 'inline-block',
      width: 6,
      backgroundColor: theme.colors.mainGreen6,
    },

    '& .tier--item__start': {
      left: 0,
    },

    '& .tier--item__end': {
      right: 0,
    },

    '&.tier-chart--item__first .tier--item__end:after, &.tier-chart--item__middle .tier--item__end:after':
      {
        content: '""',
        position: 'absolute',
        right: '6px',
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent',
        borderRight: `4px solid ${theme.colors.mainGreen6}`,
        borderLeft: '12px solid transparent',
      },
    '&.tier-chart--item__last .tier--item__start:before, &.tier-chart--item__middle .tier--item__start:before':
      {
        content: '""',
        position: 'absolute',
        left: '6px',
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent',
        borderLeft: `4px solid ${theme.colors.mainGreen6}`,
        borderRight: '12px solid transparent',
      },

    '&:hover': {
      lineHeight: '22px',
      borderTop: `1px solid ${theme.colors.mainGreen6}`,
      borderBottom: `1px solid ${theme.colors.mainGreen6}`,
      backgroundColor: theme.colors.mainGreen2,
      boxShadow:
        '0px 0px 6px -4px rgba(56, 178, 166, 0.12), 0px 0px 16px rgba(56, 178, 166, 0.08), 0px 0px 28px 8px rgba(56, 178, 166, 0.05)',
    },
  },
  tierItemTooltip: {
    '& .tier--tooltip__index': {
      color: theme.colors.gray1,
    },

    '& .tier--tooltip__range': {
      paddingLeft: 8,
      color: 'rgba(255, 255, 255, 0.65)',
    },
  },

  // tier-input-control
  tierInputContainer: {
    position: 'relative',
    width: 584,
    padding: '20px 20px 52px 20px',
    borderRadius: 2,
    backgroundColor: theme.colors.gray1,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.16)',
  },
  tierInputMain: {
    paddingBottom: 20,

    '& .tier--input__header': {
      ...theme.typography.body4,
      fontWeight: 600,
      color: theme.colors.bodyColor,
      marginBottom: 8,
    },

    '& .tier--input__row': {
      '& .ant-form-item': {
        marginBottom: 12,
      },
    },

    '& .tier--input__index': {
      ...theme.typography.body4,
      fontWeight: 700,
      color: theme.colors.disableColor,
      paddingTop: 5,
    },

    '& .tier--input__to-tenancy': {
      position: 'relative',

      '& .ant-input-number-handler-wrap': {
        opacity: '1 !important',
      },

      '& .ant-input-number-input-wrap .ant-input-number-input': {
        paddingLeft: 61,
        paddingRight: 41,
      },

      '&:before': {
        content: '"≤ "',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: 48,
        lineHeight: '32px',
        textAlign: 'center',
        color: theme.colors.disableColor,
        backgroundColor: theme.colors.gray3,
        borderRight: `1px solid ${theme.colors.gray5}`,
      },

      '&-week': {
        position: 'absolute',
        right: 0,
        top: 0,
        bottom: 0,
        fontSize: 12,
        lineHeight: '32px',
        marginRight: 32,
        color: theme.colors.disableColor,
      },
    },

    '& .tier--input__close': {
      width: 20,
      height: 20,
      fontSize: 20,
      fontWeight: 'normal',
      color: theme.colors.gray6,
      paddingLeft: 5,
      paddingTop: 5,
    },

    '& .tier--button__add': {
      paddingLeft: 0,
    },
  },
  tierInputFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 52,
    padding: '10px 16px 10px 20px',
    borderTop: '1px solid #E7E7E7',

    '& > span': {
      ...theme.typography.body4,
      color: theme.colors.bodyColor,
    },

    '& .ant-btn-primary': {
      marginLeft: 8,
    },

    '& .tier-input--button__confirm': {
      fontWeight: 600,
    },
  },
}));

export default useStyles;
